var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRegionIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "55px",
    viewBox: "0 0 62 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "region icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Requester---first-time-login-1",
    transform: "translate(-617.000000, -189.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "region-popup",
    transform: "translate(389.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "region-icon",
    transform: "translate(229.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,28 C60,30.209 58.209,32 56,32 C53.791,32 52,30.209 52,28 C52,25.791 53.791,24 56,24 C58.209,24 60,25.791 60,28 Z",
    id: "Stroke-3-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,28 C8,30.209 6.209,32 4,32 C1.791,32 0,30.209 0,28 C0,25.791 1.791,24 4,24 C6.209,24 8,25.791 8,28 Z",
    id: "Stroke-3-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6 C20,8.209 18.209,10 16,10 C13.791,10 12,8.209 12,6 C12,3.791 13.791,2 16,2 C18.209,2 20,3.791 20,6 Z",
    id: "Stroke-3-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,49 C48,51.209 46.209,53 44,53 C41.791,53 40,51.209 40,49 C40,46.791 41.791,45 44,45 C46.209,45 48,46.791 48,49 Z",
    id: "Stroke-3-Copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4641016,49.4641016 C21.4641016,51.6731016 19.6731016,53.4641016 17.4641016,53.4641016 C15.2551016,53.4641016 13.4641016,51.6731016 13.4641016,49.4641016 C13.4641016,47.2551016 15.2551016,45.4641016 17.4641016,45.4641016 C19.6731016,45.4641016 21.4641016,47.2551016 21.4641016,49.4641016 Z",
    id: "Stroke-3",
    transform: "translate(17.464102, 49.464102) rotate(-330.000000) translate(-17.464102, -49.464102) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25,5.5503268 C47.25,7.7593268 45.459,9.5503268 43.25,9.5503268 C41.041,9.5503268 39.25,7.7593268 39.25,5.5503268 C39.25,3.3413268 41.041,1.5503268 43.25,1.5503268 C45.459,1.5503268 47.25,3.3413268 47.25,5.5503268 Z",
    id: "Stroke-3-Copy",
    transform: "translate(43.250000, 5.550327) rotate(-330.000000) translate(-43.250000, -5.550327) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,28 L53,28",
    id: "Stroke-13-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,28 L20.052,28",
    id: "Stroke-13-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8046539,9.32481524 L24.7173971,19.1972357",
    id: "Stroke-13-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.947511,9.32481524 L41.8602542,19.1972357",
    id: "Stroke-13-Copy-6",
    transform: "translate(38.403883, 14.261025) scale(-1, 1) translate(-38.403883, -14.261025) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8046539,36.3248152 L42.7173971,46.1972357",
    id: "Stroke-13-Copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6617967,36.3248152 L25.5745399,46.1972357",
    id: "Stroke-13-Copy-7",
    transform: "translate(22.118168, 41.261025) scale(-1, 1) translate(-22.118168, -41.261025) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,28 C40,33.523 35.522,38 30,38 C24.478,38 20,33.523 20,28 C20,22.477 24.478,18 30,18 C35.522,18 40,22.477 40,28 Z",
    id: "Stroke-11"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRegionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/region-icon.2c288267c8187c35db773dc1ee40c8d6.svg";